"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TRAVEL_READY_ACKNOWLEDGEMENT_MAP = exports.TRAVEL_READY_ACKNOWLEDGEMENT_MAP = {
    en: {
        1: ["I have read and understood the insurance requirements to travel with G Adventures.", "I have read and understood the Traveller Code of Conduct."],
        3: ["I understand and accept the booking conditions found on the link."],
        4: ["I understand and accept the booking conditions found on the link."],
        13: ["I have read and understood the Traveller Code of Conduct."]
    },
    de: {
        1: ["Ich habe die Versicherungsanforderungen für Reisen mit G Adventures gelesen und verstanden.", "Ich habe den Verhaltenskodex für Reisende gelesen und verstanden."],
        3: ["Ich verstehe und akzeptiere die auf dem Link angegebenen Buchungsbedingungen."],
        4: ["Ich verstehe und akzeptiere die auf dem Link angegebenen Buchungsbedingungen."],
        13: ["Ich habe den Verhaltenskodex für Reisende gelesen und verstanden."]
    }
};

// Please update this if you want the link attached to a matching phrase / keyword.
var TRAVEL_READY_ACKNOWLEDGEMENT_KEYWORDS = exports.TRAVEL_READY_ACKNOWLEDGEMENT_KEYWORDS = {
    en: ["booking conditions", "Traveller Code of Conduct", "insurance requirements"],
    de: ["Buchungsbedingungen", "Verhaltenskodex für Reisende", "Versicherungsanforderungen"]
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/mappings/travel-ready.js
// module id = 1429
// module chunks = 0